class WPStampedRating extends HTMLElement {
  connectedCallback() {
    try {
      const container = this.closest('.product-stars') || this.parentElement || document;

      const findBadge = () => {
        // Search within container first
        let el = container.querySelector('.stamped-badge');
        if (el) return el;
        // Try immediate siblings if wrapper not found
        const prev = this.previousElementSibling;
        if (prev) el = prev.querySelector && prev.querySelector('.stamped-badge');
        if (el) return el;
        const next = this.nextElementSibling;
        if (next) el = next.querySelector && next.querySelector('.stamped-badge');
        return el || null;
      };

      const apply = () => {
        const ratingEl = findBadge();
        if (!ratingEl) return false;
        const caption = ratingEl.querySelector('.stamped-badge-caption');
        if (!caption) return false;

        const ratingAttr = ratingEl.getAttribute('data-rating') || (ratingEl.dataset && ratingEl.dataset.rating);
        const rating = parseFloat(ratingAttr);
        if (isNaN(rating)) return false;

        let sp = ratingEl.querySelector('.stamped-rating-value');
        if (!sp) {
          sp = document.createElement('span');
          sp.className = 'stamped-rating-value';
          ratingEl.insertBefore(sp, caption);
        }
        sp.textContent = rating.toFixed(1) + ' ';
        return true;
      };

      // Try once immediately in case Stamped has already rendered
      let hasInitial = apply();

      // If badge not present yet, observe container for child additions only
      let scheduled = false;
      const schedule = (fn) => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { fn(); scheduled = false; });
      };

      const containerObserver = new MutationObserver(() => {
        schedule(() => {
          if (apply()) {
            // Once applied successfully, stop container observer and start attribute observers
            containerObserver.disconnect();
            setupAttributeObservers();
          }
        });
      });

      const setupAttributeObservers = () => {
        const ratingEl = findBadge();
        if (!ratingEl) return;
        const caption = ratingEl.querySelector('.stamped-badge-caption');
        if (!caption) return;

        const attrObserver = new MutationObserver(() => {
          schedule(() => apply());
        });
        // Observe only relevant attributes to avoid loops from our own style changes
        attrObserver.observe(ratingEl, { attributes: true, attributeFilter: ['data-rating'] });
        attrObserver.observe(caption, { attributes: true, attributeFilter: ['data-reviews'] });
      };

      if (!hasInitial) {
        containerObserver.observe(container, { childList: true, subtree: true });
      } else {
        setupAttributeObservers();
      }
    } catch (e) {
      console.error('WPStampedRating init error', e);
    }
  }
}
if (!customElements.get('wp-stamped-rating')) {
  customElements.define('wp-stamped-rating', WPStampedRating);
}
class WPStampedCount extends HTMLElement {
  connectedCallback() {
    try {
      const container = this.closest('.product-stars.additional') || this.closest('.product-stars') || this.parentElement || document;
      container.classList.add('additional');
      const findBadge = () => {
        let el = container.querySelector('.stamped-badge');
        if (el) return el;
        const prev = this.previousElementSibling;
        if (prev) el = prev.querySelector && prev.querySelector('.stamped-badge');
        if (el) return el;
        const next = this.nextElementSibling;
        if (next) el = next.querySelector && next.querySelector('.stamped-badge');
        return el || null;
      };

      const apply = () => {
        const ratingEl = findBadge();
        if (!ratingEl) return false;
        const caption = ratingEl.querySelector('.stamped-badge-caption');
        if (!caption) return false;

        // Extract reviews count from data attribute or text
        let reviews = caption.getAttribute('data-reviews');
        if (!reviews) {
          const match = (caption.textContent || '').trim().match(/\d+/);
          reviews = match ? match[0] : '';
        }
        if (!reviews) return false;

        let count = ratingEl.querySelector('.stamped-reviews-count');
        if (!count) {
          count = document.createElement('span');
          count.className = 'stamped-reviews-count';
          ratingEl.appendChild(count);
        } 
        count.textContent = `(${reviews})`;

        // Hide original caption content if visible
        if (caption.style.display !== 'none') caption.style.display = 'none';
        return true;
      };

      // Try once immediately
      let hasInitial = apply();

      let scheduled = false;
      const schedule = (fn) => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { fn(); scheduled = false; });
      };

      const containerObserver = new MutationObserver(() => {
        schedule(() => {
          if (apply()) {
            containerObserver.disconnect();
            setupAttributeObservers();
          }
        });
      });

      const setupAttributeObservers = () => {
        const ratingEl = findBadge();
        if (!ratingEl) return;
        const caption = ratingEl.querySelector('.stamped-badge-caption');
        if (!caption) return;

        const attrObserver = new MutationObserver(() => {
          schedule(() => apply());
        });
        attrObserver.observe(caption, { attributes: true, attributeFilter: ['data-reviews'] });
        attrObserver.observe(ratingEl, { attributes: true, attributeFilter: ['data-rating'] });
      };

      if (!hasInitial) {
        containerObserver.observe(container, { childList: true, subtree: true });
      } else {
        setupAttributeObservers();
      }
    } catch (e) {
      console.error('WPStampedCount init error', e);
    }
  }
}


if (!customElements.get('wp-stamped-count')) {
  customElements.define('wp-stamped-count', WPStampedCount);
}
console.log('wp-stamped.js sss');